export default {
    // Top-level modal labels
    menuItemLabel: 'Details',
    panelHeading: 'Content details',
    modalDescription: 'Read-only metadata, collaborators, and activity for this content.',

    // Tabs
    tabs: {
        metadata: 'Metadata',
        collaborators: 'Collaborators',
        activity: 'Activity',
    },

    // Empty / loading / error states
    state: {
        loading: 'Loading details…',
        loadError: 'Could not load details.',
        noCollaborators: 'No collaborators added.',
        noActivity: 'No activity recorded yet.',
    },

    // Metadata field labels
    fields: {
        uploader: 'Uploader',
        uploaderEmail: 'Uploader email',
        uploaded: 'Uploaded',
        lastUpdated: 'Last updated',
        device: 'Device',
        fileSize: 'File size',
        duration: 'Duration',
        resolution: 'Resolution',
        mimeType: 'MIME type',
        originalFilename: 'Original filename',
        filestackStatus: 'Filestack status',
    },

    // Inline values
    values: {
        addedAt: 'Added {date}',
        actorSystem: 'System',
        actorUserFallback: 'User #{id}',
        activityWithActor: '{label} by {actor}',
    },

    // Activity timeline event labels
    activityType: {
        contentUploaded: 'Content uploaded',
        commentAdded: 'Comment added',
        commentEdited: 'Comment edited',
        commentDeleted: 'Comment deleted',
        comment: 'Comment',
        proofingAdded: 'Proofing comment added',
        proofingEdited: 'Proofing comment edited',
        proofingDeleted: 'Proofing comment deleted',
        collaboratorAdded: 'Collaborator added',
        collaboratorRemoved: 'Collaborator removed',
        collaborator: 'Collaborator change',
        editRequested: 'Edit requested',
        editClaimed: 'Edit claimed',
        editAssigned: 'Edit assigned',
        editReassigned: 'Edit reassigned',
        editDelivered: 'Edit delivered',
        editDeclined: 'Edit declined',
        editUpdated: 'Edit updated',
        qcClaimed: 'QC claimed',
        qcAccepted: 'QC accepted',
        qcDeclined: 'QC declined',
        markedIncompleted: 'Marked incompleted',
        markedCompleted: 'Marked completed',
        statusChanged: 'Status changed to {status}',
        productionTagged: 'Tagged to production',
        productionRetagged: 'Production changed',
        productionRemoved: 'Removed from production',
    },

    // Human-friendly labels for the raw `edited_statuses_history.status`
    // values (needsinfo / editready / etc.) — interpolated into
    // activityType.statusChanged.
    statusValues: {
        needsinfo: 'Needs Info',
        editready: 'Edit Ready',
        editing: 'Editing',
        completed: 'Completed',
        notforedit: 'Not for Edit',
    },
}
